<div *ngIf="!hasSelectedCompany">
  <input
    class="input-legacy"
    type="text"
    placeholder="{{ 'MAINTENANCES.COMPANY_PLACEHOLDER' | translate }}"
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
  />

  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedCompany()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option *ngFor="let company of companies" [value]="company.id">
      {{ company.name }}
    </mat-option>
    <mat-option *ngIf="!companies.length">
      {{ 'MAINTENANCES.COMPANY_NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>
</div>

<div class="selected-input" *ngIf="hasSelectedCompany">
  <input class="input-legacy" type="text" disabled [value]="selectedCompany.name" />

  <button mat-icon-button class="cancel-button accent-700-fg" *ngIf="hasSelectedCompany" (click)="deselectCompany()">
    <mat-icon>cancel</mat-icon>
  </button>
</div>
